<div class="wrapper">
  <div class="thumbnail pointer"
       (click)="openYoutubeDialog()"
       appTrack="youtubePreview"
       [appTrackProps]="{ video: youtubeVideosReverseMap[videoId] }">
    <img
      [src]="(prefix + thumbnail) | safeUrl"
      alt="Video preview"
      class="youtube-preview-img"
      [class]="height ? 'cover' : 'ratio-16x9'"
      [style.height]="height + ' !important'"
    />
    <img src="assets/img/icons/youtube.svg" [style.top]="top" class="icon-play" alt="youtube" />
  </div>
</div>
